import { ValidationError } from "sequelize"
import {
    OkrKeyResultComment,
    OkrKeyResultCommentCreate,
    OkrKeyResultCommentSave,
    OkrKeyResultCommentAttachment,
    SaveOkrKeyResultCommentAttachmentType,
    MtDriveFile,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import { LangType } from "client/store"
import { OkrKeyResultCommentValidation } from "./types"


export const LoadAllOkrKeyResultComments = (keyResultId: number) => (
    GET(`/okrKeyResultComment/keyResultId/${keyResultId}`)
    .then((comments: OkrKeyResultComment[]) => comments)
)

export const LoadOkrKeyResultCommentById = (commentId: number) => (
    GET(`/okrKeyResultComment/id/${commentId}`)
    .then((comment: OkrKeyResultComment) => comment)
)

export const SaveOkrKeyResultComment = (
    id: number,
    comment: OkrKeyResultCommentCreate,
    attachments: readonly MtDriveFile[],
    lang: LangType,
) => {
    const data: OkrKeyResultCommentSave = {
        id,
        comment,
    }
    return POST(
        "/okrKeyResultComment/save",
        JSON.stringify(data),
    ).then((res) => {
        const newComment = res as OkrKeyResultComment
        const error = res as ValidationError

        const newCommentId = newComment.id || null
        const validation = <OkrKeyResultCommentValidation>validate(error, lang)

        if (validation) {
            return {
                newCommentId,
                validation,
            }
        }

        const attachmentData: OkrKeyResultCommentAttachment[] = []
        attachments.forEach((file, index) => {
            attachmentData.push({
                commentId: newCommentId || id,
                fileId: file.id,
                order: index,
            })
        })

        return SaveOkrKeyResultCommentAttachments(newCommentId || id, attachmentData)
        .then(() => ({
            newCommentId,
            validation,
        }))
    })
}

export const DeleteOkrKeyResultComment = (
    commentId: number,
    keyResultId: number,
) => (
    DELETE(`/okrKeyResultComment/delete/${commentId}/${keyResultId}`)
    .then((removedRows: number) => removedRows)
)

export const LoadOkrKeyResultCommentAttachments = (commentId: number) => (
    GET(`/okrKeyResultCommentAttachment/commentId/${commentId}`)
    .then((attachments: OkrKeyResultCommentAttachment[]) => attachments)
)

export const SaveOkrKeyResultCommentAttachments = (
    commentId: number,
    attachments: OkrKeyResultCommentAttachment[],
) => {
    const attachmentsData: SaveOkrKeyResultCommentAttachmentType = {
        commentId,
        attachments,
    }
    return POST(
        "/okrKeyResultCommentAttachment/save",
        JSON.stringify(attachmentsData),
    )
}
